import { AppBar, Box, Toolbar } from "@mui/material";
import { User } from "oidc-client";
import React, { Suspense, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import OverlaySpinner from "./shared/OverlaySpinner";
import { Header } from "./shared/components/Header";
import authService from "./shared/services/AuthService";

const [Reports, Manage, Profiles, Providers] = [
  React.lazy(() => import("./report/App")),
  React.lazy(() => import("./manage/App")),
  React.lazy(() => import("./profiles/App")),
  React.lazy(() => import("./providers/App")),
];

function App() {
  /** Authenticated user, here as state to trigger redraw on login. */
  const [user, setUser] = useState<User | undefined>();

  useEffect(() => {
    authService.getUser().then((user) => {
      if (user) {
        setUser(user);
      } else {
        authService.login();
      }
    });
  }, []);

  if (!user) return null;

  return (
    user && (
      <>
        <AppBar
          position="sticky"
          component="nav"
          style={{ backgroundColor: "#00B0BA" }}
        >
          <Toolbar>
            <Header />
          </Toolbar>
        </AppBar>
        <Box style={{ margin: 20 }}>
          <Suspense fallback={<OverlaySpinner />}>
            <Routes>
              <Route path="/report/*" element={<Reports />} />
              <Route path="/manage/*" element={<Manage />} />
              <Route path="/profiles/*" element={<Profiles />} />
              <Route path="/providers/*" element={<Providers />} />
              <Route path="/" element={<Navigate to="/report" />} />
            </Routes>
          </Suspense>
        </Box>
      </>
    )
  );
}

export default App;
